import { useState, useEffect, useRef } from 'react';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'nav-scrolled border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer shrink-0"
          >
            <span className={`font-heading text-lg md:text-2xl font-bold transition-colors duration-300 ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              cssspreadsheet<span className="text-accent-500">.</span>beauty
            </span>
          </a>

          <div className="flex items-center gap-2 md:gap-5">
            {/* Hamburger Categories Menu */}
            <div className="relative" ref={menuRef}>
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className={`flex items-center justify-center w-10 h-10 rounded-full border transition-all duration-200 cursor-pointer shrink-0 ${
                  scrolled
                    ? 'border-foreground-300 text-foreground-700 hover:border-foreground-500 bg-white'
                    : 'border-white/40 text-white hover:border-white/80 bg-white/10 backdrop-blur-sm'
                }`}
                aria-label="Open categories menu"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-lg`}></i>
                </span>
              </button>

              {menuOpen && (
                <div className="absolute top-full mt-2 right-0 w-72 md:w-80 bg-white rounded-2xl border border-background-200/80 py-3 max-h-[70vh] overflow-y-auto animate-fade-in shadow-lg">
                  <div className="px-4 py-2 border-b border-background-100 mb-1">
                    <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
                      Categories
                    </span>
                  </div>
                  {categories.map((cat) => (
                    <a
                      key={cat.slug}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-accent-50 hover:text-accent-700 transition-colors duration-150 cursor-pointer"
                      onClick={() => setMenuOpen(false)}
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-accent-400 shrink-0"></span>
                      {cat.name}
                    </a>
                  ))}
                  <div className="mt-2 pt-2 border-t border-background-100 px-4 pb-1">
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2 py-2 text-sm font-medium text-foreground-700 hover:text-accent-700 transition-colors duration-150 cursor-pointer"
                      onClick={() => setMenuOpen(false)}
                    >
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-external-link-line text-xs"></i>
                      </span>
                      cssbuy sheet
                    </a>
                  </div>
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`hidden sm:inline-flex text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              cssbuy sheet
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-1.5 px-4 md:px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-white text-foreground-950 hover:bg-background-100 shrink-0"
            >
              <span className="hidden sm:inline">buy it now</span>
              <span className="sm:hidden">buy</span>
              <span className="w-4 h-4 flex items-center justify-center shrink-0">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}